export default {
  "account-settings": () => import("/app/browser/layouts/account-settings.vue"),
  account: () => import("/app/browser/layouts/account.vue"),
  default: () => import("/app/browser/layouts/default.vue"),
  "no-header-footer": () => import("/app/browser/layouts/no-header-footer.vue"),
  registration: () => import("/app/browser/layouts/registration.vue"),
  sale: () => import("/app/browser/layouts/sale.vue")
}